if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		constructor(){

			super();

			const qty = this.querySelector('.qty-selector'),
						qtyMinus = this.querySelector('.qty-minus'),
						qtyPlus = this.querySelector('.qty-plus'),
						qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
						qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;

			if ( parseInt(qty.value) - 1 < qtyMin ) {
				qtyMinus.classList.add('disabled');
			}
			if ( parseInt(qty.value) + 1 > qtyMax ) {
				qtyPlus.classList.add('disabled');
			}

			qty.addEventListener('change', (e)=>{
				const currentQty = parseInt(qty.value);
				if ( parseInt(qty.value) - 1 < qtyMin ) {
					qtyMinus.classList.add('disabled');
				} else {
					qtyMinus.classList.remove('disabled');
				}
				if ( parseInt(qty.value) + 1 > qtyMax ) {
					qtyPlus.classList.add('disabled');
				} else {
					qtyPlus.classList.remove('disabled');
				}
			});

			qtyMinus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyMinus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
					if ( currentQty - 1 >= qtyMin ) {
						qty.value = currentQty - 1;
						qtyPlus.classList.remove('disabled');
					} 
					if ( currentQty - 1 <= qtyMin ) {
						qtyMinus.classList.add('disabled');
					}

					/* begin POCH */
					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.updateDiscount();
					// this.updateDiscount();
					/* end POCH */
				}
			});

			qtyPlus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyPlus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
					if ( currentQty + 1 <= qtyMax ) {
						qty.value = currentQty + 1;
						qtyMinus.classList.remove('disabled');
					} 
					if ( currentQty + 1 >= qtyMax ) {
						qtyPlus.classList.add('disabled');
					}

					/* begin POCH */
					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.updateDiscount();
					// this.updateDiscount();
					/* end POCH */
				}
			});

			/* begin POCH */
			/*const cartItems = document.getElementById('AjaxCartForm');
		    cartItems.applyDiscount(qty);*/
			this.applyDiscount(qty);
			/* end POCH */
		}

        /* begin POCH */
        applyDiscount(input) {
          const cartRemainingDiscount = document.querySelector('.cart-remaining-discount'),
                cartDiscountApplied = document.querySelector('.cart-discount-applied'),
                qtyRemainingDiscount = document.querySelector('.qty-remaining-discount'),
                cartHolder = document.querySelector('.cart-holder');
          
          if ( cartRemainingDiscount != 'undefined' && cartRemainingDiscount != null ) {
    		cartRemainingDiscount.addEventListener('click', (e) => {
				e.preventDefault();
				if ( cartHolder != 'undefined' && cartHolder.getAttribute("data-items") == 1 ) {
				  input.value = cartRemainingDiscount.getAttribute('data-qty');
                  input.dispatchEvent(new Event("input"));
                  cartRemainingDiscount.classList.add('d-none');
                  cartDiscountApplied.classList.remove('d-none');
                  qtyRemainingDiscount.innerHTML = 0;
				}
			});
          }
        }
        /* end POCH */

        /* begin POCH */
        /*updateDiscount() {
          const cartRemainingDiscount = document.querySelector('.cart-remaining-discount'),
                qtyRemainingDiscount = document.querySelector('.qty-remaining-discount'),
                cartHolder = document.querySelector('.cart-holder'),
                cartItems = document.getElementById('AjaxCartForm');
                  
          if ( cartRemainingDiscount != 'undefined' ) {
            let totalQty = 0;
            cartItems.querySelectorAll('[data-js-cart-item]').forEach(item => {
              const qty = item.querySelector('.qty');
              if ( qty ) {
                totalQty = totalQty + parseInt(qty.value);
              }
            })
            
            let discountQty = cartRemainingDiscount.getAttribute('data-qty');
            
            if ( totalQty >= 5 ) {
              cartRemainingDiscount.classList.add('d-none');
              qtyRemainingDiscount.innerHTML = 0;
            }
            else if ( totalQty <= 0 ) {
              cartRemainingDiscount.classList.add('d-none');
              qtyRemainingDiscount.innerHTML = discountQty;
            }
            else {
              cartRemainingDiscount.classList.remove('d-none');
              if ( cartHolder != 'undefined' ) {
                if ( cartHolder.getAttribute("data-items") == 1 ) {
                  if ( ! cartRemainingDiscount.classList.contains('button') ) {
                    cartRemainingDiscount.classList.add('button');
                  }
                  if ( ! cartRemainingDiscount.classList.contains('button--regular') ) {
                    cartRemainingDiscount.classList.add('button--regular');
                  }
                }
                else {
                  cartRemainingDiscount.classList.remove('button');
                  cartRemainingDiscount.classList.remove('button--regular');
                }
              }
              qtyRemainingDiscount.innerHTML = discountQty - totalQty;
            }
          }
        }*/
        /* end POCH */
		
	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
	}

}